export const PASSWORD_INPUT_CLASS = {
    SHOW: 'fa fa-eye',
    HIDE: 'fa fa-eye-slash'
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/password.constants.ts